import { render, staticRenderFns } from "./QuizCommand.vue?vue&type=template&id=361ef232"
import script from "./QuizCommand.vue?vue&type=script&lang=js"
export * from "./QuizCommand.vue?vue&type=script&lang=js"
import style0 from "./QuizCommand.vue?vue&type=style&index=0&id=361ef232&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports